// ─── AVAIA — Theme JavaScript v2 ──────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', () => {

  // ─── Logo gold animation ──────────────────────────────────────────────────
  const logoWordmark = document.querySelector('.logo-wordmark');
  if (logoWordmark) {
    logoWordmark.addEventListener('click', function(e) {
      e.preventDefault();
      this.classList.remove('gold-flash');
      void this.offsetWidth; // reset animation
      this.classList.add('gold-flash');
      setTimeout(() => {
        this.classList.remove('gold-flash');
        window.location.href = this.getAttribute('href');
      }, 400);
    });
  }

  // ─── Active nav link ──────────────────────────────────────────────────────
  const currentPath = window.location.pathname;
  document.querySelectorAll('.nav-left a').forEach(link => {
    if (link.getAttribute('href') && currentPath.includes(link.getAttribute('href').split('/').pop())) {
      link.classList.add('active');
    }
  });

  // ─── Mobile menu ─────────────────────────────────────────────────────────
  const menuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileClose = document.querySelector('.mobile-menu-close');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
    if (mobileClose) {
      mobileClose.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
      });
    }
  }

  // ─── FAQ accordion ────────────────────────────────────────────────────────
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => {
        i.classList.remove('open');
        const b = i.querySelector('.faq-question');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ─── Product detail accordion ─────────────────────────────────────────────
  document.querySelectorAll('.accordion-header').forEach(h => {
    h.addEventListener('click', () => {
      h.parentElement.classList.toggle('open');
    });
  });

  // ─── Product gallery thumbnails ───────────────────────────────────────────
  const galleryMainImg = document.querySelector('.gallery-main img');

  // Préchargement au survol pour un switch instantané
  document.querySelectorAll('.gallery-thumb').forEach(thumb => {
    thumb.addEventListener('mouseenter', () => {
      if (thumb.dataset.src) {
        var pre = new Image();
        pre.src = thumb.dataset.src;
      }
    });

    thumb.addEventListener('click', () => {
      document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (galleryMainImg && thumb.dataset.src) {
        // Fade out
        galleryMainImg.style.opacity = '0';
        // Charger la nouvelle image, fade in seulement quand elle est prête
        var newImg = new Image();
        newImg.onload = function() {
          galleryMainImg.src = thumb.dataset.src;
          galleryMainImg.style.opacity = '1';
        };
        newImg.onerror = function() {
          galleryMainImg.src = thumb.dataset.src;
          galleryMainImg.style.opacity = '1';
        };
        newImg.src = thumb.dataset.src;
      }
    });
  });

  // ─── Collection filter + search ───────────────────────────────────────────
  const grid        = document.getElementById('products-grid');
  const searchInput = document.getElementById('collection-search');
  const countEl     = document.getElementById('results-count');
  const noResults   = document.getElementById('coll-no-results');

  // Badge filtres actifs
  function updateFilterBadge() {
    const badge = document.getElementById('coll-filter-badge');
    if (!badge) return;
    let count = 0;
    const v = document.querySelector('.coll-filter-btn.active[data-vendor]');
    if (v && v.dataset.vendor !== 'all') count++;
    const e = document.querySelector('.coll-etat-btn.active');
    if (e && e.dataset.etat !== 'all') count++;
    const p = document.querySelector('.coll-prix-btn.active');
    if (p && !(p.dataset.min === '0' && p.dataset.max === '999999')) count++;
    const s = document.getElementById('collection-search');
    if (s && s.value.trim()) count++;
    badge.textContent = count > 0 ? count : '';
    badge.style.display = count > 0 ? 'inline-flex' : 'none';
  }

  // Toggle panel filtres (mobile)
  const filterToggle = document.getElementById('coll-filters-toggle');
  const filterPanel  = document.getElementById('coll-filters-panel');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', () => {
      const isOpen = filterPanel.classList.toggle('open');
      filterToggle.setAttribute('aria-expanded', isOpen);
      filterToggle.classList.toggle('active', isOpen);
    });
  }

  if (grid) {
    let activeVendor = 'all';
    let activeEtat   = 'all';
    let activePrixMin = 0;
    let activePrixMax = 999999;
    let searchQuery  = '';

    function normalizeEtat(str) {
      return str.toLowerCase()
        .replace(/[éèêë]/g, 'e')
        .replace(/[àâä]/g, 'a')
        .replace(/[ùûü]/g, 'u')
        .replace(/[îï]/g, 'i')
        .replace(/[ôö]/g, 'o')
        .replace(/\s+/g, '-');
    }

    function applyFilters() {
      const cards = grid.querySelectorAll('.product-card');
      let visible = 0;
      cards.forEach(card => {
        const vendor = card.dataset.vendor || '';
        const title  = card.dataset.title  || '';
        const etat   = normalizeEtat(card.dataset.etat || '');
        const price  = parseFloat(card.dataset.price || '0');
        const matchVendor = activeVendor === 'all' || vendor === activeVendor;
        const matchEtat   = activeEtat   === 'all' || etat.includes(activeEtat);
        const matchPrix   = price >= activePrixMin && price <= activePrixMax;
        const matchSearch = title.includes(searchQuery);
        const show = matchVendor && matchEtat && matchPrix && matchSearch;
        card.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (countEl) countEl.textContent = visible + ' pièce' + (visible > 1 ? 's' : '') + ' disponible' + (visible > 1 ? 's' : '');
      if (noResults) noResults.style.display = visible === 0 ? 'block' : 'none';
      if (grid) grid.style.display = visible === 0 ? 'none' : '';
      try {
        sessionStorage.setItem('avaia_coll_filters', JSON.stringify({
          v: activeVendor, e: activeEtat, min: activePrixMin, max: activePrixMax, q: searchQuery
        }));
      } catch(e) {}
    }

    // Boutons de filtre marque (nouveau + legacy)
    document.querySelectorAll('.coll-filter-btn[data-vendor], .filter-btn[data-vendor]').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('.coll-filter-btn[data-vendor], .filter-btn[data-vendor]').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        activeVendor = btn.dataset.vendor;
        applyFilters();
        updateFilterBadge();
      });
    });

    // Reset depuis le message "aucun résultat"
    if (noResults) {
      const resetBtn = noResults.querySelector('.coll-no-results-reset');
      if (resetBtn) resetBtn.addEventListener('click', () => {
        activeVendor = 'all';
        activeEtat = 'all';
        searchQuery = '';
        if (searchInput) searchInput.value = '';
        document.querySelectorAll('.coll-filter-btn[data-vendor]').forEach(b => b.classList.remove('active'));
        document.querySelector('.coll-filter-btn[data-vendor="all"]')?.classList.add('active');
        document.querySelectorAll('.coll-etat-btn').forEach(b => b.classList.remove('active'));
        document.querySelector('.coll-etat-btn[data-etat="all"]')?.classList.add('active');
        applyFilters();
      });
    }

    // Boutons de filtre prix
    document.querySelectorAll('.coll-prix-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('.coll-prix-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        activePrixMin = parseFloat(btn.dataset.min);
        activePrixMax = parseFloat(btn.dataset.max);
        applyFilters();
        updateFilterBadge();
      });
    });

    // Boutons de filtre état
    document.querySelectorAll('.coll-etat-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('.coll-etat-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        activeEtat = btn.dataset.etat;
        applyFilters();
        updateFilterBadge();
      });
    });

    // Recherche texte (nouveau input .coll-search-input)
    const collSearchInput = document.getElementById('collection-search');
    if (collSearchInput) {
      collSearchInput.addEventListener('input', () => {
        searchQuery = collSearchInput.value.toLowerCase().trim();
        applyFilters();
        updateFilterBadge();
      });
    }

    // Restauration des filtres (survit à la pagination et au retour navigateur)
    try {
      const saved = JSON.parse(sessionStorage.getItem('avaia_coll_filters') || 'null');
      if (saved) {
        if (saved.v && saved.v !== 'all') {
          const b = document.querySelector('.coll-filter-btn[data-vendor="' + CSS.escape(saved.v) + '"]');
          if (b) { document.querySelectorAll('.coll-filter-btn[data-vendor]').forEach(x => x.classList.remove('active')); b.classList.add('active'); activeVendor = saved.v; }
        }
        if (saved.e && saved.e !== 'all') {
          const b = document.querySelector('.coll-etat-btn[data-etat="' + CSS.escape(saved.e) + '"]');
          if (b) { document.querySelectorAll('.coll-etat-btn').forEach(x => x.classList.remove('active')); b.classList.add('active'); activeEtat = saved.e; }
        }
        if (typeof saved.min === 'number' && typeof saved.max === 'number' && !(saved.min === 0 && saved.max === 999999)) {
          const b = document.querySelector('.coll-prix-btn[data-min="' + saved.min + '"][data-max="' + saved.max + '"]');
          if (b) { document.querySelectorAll('.coll-prix-btn').forEach(x => x.classList.remove('active')); b.classList.add('active'); activePrixMin = saved.min; activePrixMax = saved.max; }
        }
        if (saved.q && collSearchInput) { collSearchInput.value = saved.q; searchQuery = saved.q; }
        applyFilters();
        updateFilterBadge();
      }
    } catch(e) {}
  }

  // ─── Newsletter form feedback ─────────────────────────────────────────────
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', e => {
      const btn = newsletterForm.querySelector('button[type="submit"]');
      if (btn) {
        btn.textContent = 'Merci !';
        btn.disabled = true;
        setTimeout(() => {
          btn.textContent = "S'inscrire";
          btn.disabled = false;
        }, 3000);
      }
    });
  }

  // ─── File upload zone ─────────────────────────────────────────────────────
  const uploadZone = document.querySelector('.file-upload-zone');
  const fileInput = document.querySelector('#file-input');
  if (uploadZone && fileInput) {
    uploadZone.addEventListener('click', () => fileInput.click());
    fileInput.addEventListener('change', () => {
      const count = fileInput.files.length;
      if (count > 0) {
        const p = uploadZone.querySelector('p');
        if (p) p.innerHTML = `${count} photo${count > 1 ? 's' : ''} sélectionnée${count > 1 ? 's' : ''}`;
      }
    });
  }

  // ─── Search overlay ──────────────────────────────────────────────────────
  const searchToggle   = document.getElementById('search-toggle');
  const searchOverlay  = document.getElementById('search-overlay');
  const searchClose    = document.getElementById('search-overlay-close');
  const searchQueryInput = document.getElementById('search-input');

  const suggestionsList = document.getElementById('search-suggestions');
  const searchHint      = document.getElementById('search-hint');

  function closeSearch() {
    searchOverlay.classList.remove('open');
    document.body.style.overflow = '';
    if (suggestionsList) suggestionsList.innerHTML = '';
  }

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', () => {
      searchOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      setTimeout(() => { if (searchQueryInput) searchQueryInput.focus(); }, 100);
    });
    if (searchClose) searchClose.addEventListener('click', closeSearch);
    searchOverlay.addEventListener('click', e => { if (e.target === searchOverlay) closeSearch(); });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && searchOverlay.classList.contains('open')) closeSearch();
    });

    // ── Predictive search ──
    let searchTimer;
    if (searchQueryInput && suggestionsList) {
      searchQueryInput.addEventListener('input', () => {
        clearTimeout(searchTimer);
        const q = searchQueryInput.value.trim();
        if (q.length < 1) { suggestionsList.innerHTML = ''; if (searchHint) searchHint.style.display = ''; return; }
        searchTimer = setTimeout(() => {
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5')
            .then(r => r.json())
            .then(data => {
              const products = data.resources && data.resources.results && data.resources.results.products || [];
              suggestionsList.innerHTML = '';
              if (searchHint) searchHint.style.display = products.length ? 'none' : '';
              products.forEach(p => {
                const li = document.createElement('li');
                const price = p.price ? parseInt(p.price).toLocaleString('fr-FR') + ' €' : '';

                // Construction DOM sécurisée — pas d'innerHTML avec données externes
                const a = document.createElement('a');
                a.className = 'search-suggestion';
                a.href = p.url; // URL Shopify contrôlée

                const imgWrap = document.createElement('div');
                imgWrap.className = 'search-suggestion-img';
                if (p.featured_image && p.featured_image.url) {
                  const img = document.createElement('img');
                  img.src = p.featured_image.url;
                  img.alt = p.title || '';
                  imgWrap.appendChild(img);
                }

                const info = document.createElement('div');
                info.className = 'search-suggestion-info';

                const vendor = document.createElement('p');
                vendor.className = 'search-suggestion-vendor';
                vendor.textContent = p.vendor || '';

                const title = document.createElement('p');
                title.className = 'search-suggestion-title';
                title.textContent = p.title || '';

                info.appendChild(vendor);
                info.appendChild(title);

                const priceEl = document.createElement('span');
                priceEl.className = 'search-suggestion-price';
                priceEl.textContent = price;

                a.appendChild(imgWrap);
                a.appendChild(info);
                a.appendChild(priceEl);
                li.appendChild(a);
                suggestionsList.appendChild(li);
              });
            })
            .catch(() => {});
        }, 280);
      });
    }
  }

  // ─── Sticky header shadow ─────────────────────────────────────────────────
  const siteHeader = document.querySelector('header');
  if (siteHeader) {
    window.addEventListener('scroll', () => {
      siteHeader.style.boxShadow = window.scrollY > 10 ? '0 2px 20px rgba(0,0,0,.06)' : '';
    }, { passive: true });
  }

  // ─── Wishlist (localStorage) ──────────────────────────────────────────────
  const WISHLIST_KEY = 'avaia_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); }
    catch(e) { return []; }
  }

  function toggleWishlist(id) {
    const list = getWishlist();
    const idx = list.indexOf(String(id));
    if (idx === -1) list.push(String(id));
    else list.splice(idx, 1);
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    return idx === -1; // true = ajouté
  }

  // Bouton FAVORIS sur la fiche produit
  const favorisBtn = document.querySelector('.btn-favoris');
  if (favorisBtn) {
    const pid = favorisBtn.dataset.productId;
    const proofLikes = document.getElementById('proof-likes');
    const refresh = () => {
      const saved = getWishlist().includes(String(pid));
      favorisBtn.classList.toggle('active', saved);
      favorisBtn.innerHTML = saved
        ? '<svg viewBox="0 0 24 24" width="14" height="14" style="margin-right:6px;flex-shrink:0;fill:currentColor;stroke:currentColor;stroke-width:1.5;"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg> Sauvegardé'
        : '♡ Favoris';
      if (proofLikes) {
        const base = parseInt(proofLikes.dataset.base || '0', 10);
        proofLikes.textContent = saved ? base + 1 : base;
        const fav = proofLikes.closest('.product-etat-fav');
        if (fav) fav.classList.toggle('active', saved);
      }
    };
    refresh();
    favorisBtn.addEventListener('click', () => { toggleWishlist(pid); refresh(); });
  }

  // Cœurs sur les cartes éditoriales (page d'accueil)
  document.querySelectorAll('.ef-likes[data-product-id]').forEach(el => {
    const pid = el.dataset.productId;
    const base = parseInt(el.dataset.baseCount || '0', 10);
    const svg = el.querySelector('svg');
    const countEl = el.querySelector('.ef-likes-count');
    const refresh = () => {
      const saved = getWishlist().includes(String(pid));
      el.classList.toggle('active', saved);
      if (svg) svg.style.fill = saved ? 'var(--black)' : 'none';
      if (countEl) countEl.textContent = saved ? base + 1 : base;
    };
    refresh();
    el.addEventListener('click', e => { e.preventDefault(); toggleWishlist(pid); refresh(); });
  });

  // Cœurs sur les cartes produit
  document.querySelectorAll('.product-wishlist[data-product-id]').forEach(el => {
    const pid = el.dataset.productId;
    const base = parseInt(el.dataset.baseCount || '0', 10);
    const svg = el.querySelector('svg');
    const countEl = el.querySelector('.wishlist-count');
    const refresh = () => {
      const saved = getWishlist().includes(String(pid));
      el.classList.toggle('active', saved);
      if (svg) svg.style.fill = saved ? 'var(--black)' : 'none';
      if (countEl) countEl.textContent = saved ? base + 1 : base;
    };
    refresh();
    el.addEventListener('click', e => { e.preventDefault(); toggleWishlist(pid); refresh(); });
  });

});
